import { render, staticRenderFns } from "./FilterItem.vue?vue&type=template&id=bd28e2a2&scoped=true&"
import script from "./FilterItem.vue?vue&type=script&lang=js&"
export * from "./FilterItem.vue?vue&type=script&lang=js&"
import style0 from "./FilterItem.vue?vue&type=style&index=0&id=bd28e2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd28e2a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd28e2a2')) {
      api.createRecord('bd28e2a2', component.options)
    } else {
      api.reload('bd28e2a2', component.options)
    }
    module.hot.accept("./FilterItem.vue?vue&type=template&id=bd28e2a2&scoped=true&", function () {
      api.rerender('bd28e2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/FilterItem.vue"
export default component.exports